export default {
  methods: {
    showLoadingOverlay(message = '') {
      this.$store.commit('showLoadingMessage', message);
    },
    hideLoadingOverlay() {
      this.$store.commit('hideLoadingMessage');
    },
  },
};
